module.exports = __webpack_public_path__ + "img/free.93de6704.svg";